import { gql } from '@apollo/client/core';

const CityFragment = gql`
  fragment TestimonialFragment on Testimonial {
    id
    sign
    skills
    author {
      email
      avatarUrl
      firstname
      jobTitle
      lastname
    }
    requestor {
      firstname
      lastname
      slug
    }
    position
    description
    state
  }
`;

export default CityFragment;
